import { default as _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta } from "/opt/buildhome/repo/pages/[slug].vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47account_46vueMeta } from "/opt/buildhome/repo/pages/account.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta } from "/opt/buildhome/repo/pages/benchmark.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47contact_46vueMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta } from "/opt/buildhome/repo/pages/cookie-test.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47faq_46vueMeta } from "/opt/buildhome/repo/pages/faq.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta } from "/opt/buildhome/repo/pages/gallery.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47home_46vueMeta } from "/opt/buildhome/repo/pages/home.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47index_46vueMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47logout_46vueMeta } from "/opt/buildhome/repo/pages/logout.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta } from "/opt/buildhome/repo/pages/members/[slug].vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta } from "/opt/buildhome/repo/pages/members/event/[slug].vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta } from "/opt/buildhome/repo/pages/members/index.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta } from "/opt/buildhome/repo/pages/members/profile/index.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta } from "/opt/buildhome/repo/pages/modularEvents/[slug].vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta } from "/opt/buildhome/repo/pages/news/[slug].vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta } from "/opt/buildhome/repo/pages/news/index.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta } from "/opt/buildhome/repo/pages/nxtgen.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47playground_46vueMeta } from "/opt/buildhome/repo/pages/playground.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta } from "/opt/buildhome/repo/pages/sign-up.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta } from "/opt/buildhome/repo/pages/spacecraft-fleet.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta } from "/opt/buildhome/repo/pages/spaceflight-experience.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta } from "/opt/buildhome/repo/pages/spaceport-america.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta } from "/opt/buildhome/repo/pages/thank-you.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47verify_46vueMeta } from "/opt/buildhome/repo/pages/verify.vue?macro=true";
import { default as _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta } from "/opt/buildhome/repo/pages/webgl-sandbox.vue?macro=true";
export default [
  {
    name: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.name ?? "slug___en",
    path: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.path ?? "/:slug",
    file: "/opt/buildhome/repo/pages/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.name ?? "slug___fr",
    path: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.path ?? "/fr/:slug",
    file: "/opt/buildhome/repo/pages/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.name ?? "slug___es",
    path: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.path ?? "/es/:slug",
    file: "/opt/buildhome/repo/pages/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.name ?? "slug___it",
    path: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.path ?? "/it/:slug",
    file: "/opt/buildhome/repo/pages/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.name ?? "slug___de",
    path: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.path ?? "/de/:slug",
    file: "/opt/buildhome/repo/pages/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.name ?? "account___en",
    path: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.path ?? "/account",
    file: "/opt/buildhome/repo/pages/account.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47account_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/account.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.name ?? "account___fr",
    path: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.path ?? "/fr/account",
    file: "/opt/buildhome/repo/pages/account.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47account_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/account.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.name ?? "account___es",
    path: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.path ?? "/es/account",
    file: "/opt/buildhome/repo/pages/account.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47account_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/account.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.name ?? "account___it",
    path: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.path ?? "/it/account",
    file: "/opt/buildhome/repo/pages/account.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47account_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/account.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.name ?? "account___de",
    path: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.path ?? "/de/account",
    file: "/opt/buildhome/repo/pages/account.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47account_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47account_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/account.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.name ?? "benchmark___en",
    path: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.path ?? "/benchmark",
    file: "/opt/buildhome/repo/pages/benchmark.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/benchmark.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.name ?? "benchmark___fr",
    path: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.path ?? "/fr/benchmark",
    file: "/opt/buildhome/repo/pages/benchmark.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/benchmark.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.name ?? "benchmark___es",
    path: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.path ?? "/es/benchmark",
    file: "/opt/buildhome/repo/pages/benchmark.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/benchmark.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.name ?? "benchmark___it",
    path: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.path ?? "/it/benchmark",
    file: "/opt/buildhome/repo/pages/benchmark.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/benchmark.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.name ?? "benchmark___de",
    path: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.path ?? "/de/benchmark",
    file: "/opt/buildhome/repo/pages/benchmark.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47benchmark_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/benchmark.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.name ?? "contact___en",
    path: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.path ?? "/contact",
    file: "/opt/buildhome/repo/pages/contact.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.name ?? "contact___fr",
    path: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.path ?? "/fr/contact",
    file: "/opt/buildhome/repo/pages/contact.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.name ?? "contact___es",
    path: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.path ?? "/es/contact",
    file: "/opt/buildhome/repo/pages/contact.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.name ?? "contact___it",
    path: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.path ?? "/it/contact",
    file: "/opt/buildhome/repo/pages/contact.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.name ?? "contact___de",
    path: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.path ?? "/de/contact",
    file: "/opt/buildhome/repo/pages/contact.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47contact_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.name ?? "cookie-test___en",
    path: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.path ?? "/cookie-test",
    file: "/opt/buildhome/repo/pages/cookie-test.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/cookie-test.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.name ?? "cookie-test___fr",
    path: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.path ?? "/fr/cookie-test",
    file: "/opt/buildhome/repo/pages/cookie-test.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/cookie-test.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.name ?? "cookie-test___es",
    path: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.path ?? "/es/cookie-test",
    file: "/opt/buildhome/repo/pages/cookie-test.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/cookie-test.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.name ?? "cookie-test___it",
    path: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.path ?? "/it/cookie-test",
    file: "/opt/buildhome/repo/pages/cookie-test.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/cookie-test.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.name ?? "cookie-test___de",
    path: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.path ?? "/de/cookie-test",
    file: "/opt/buildhome/repo/pages/cookie-test.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47cookie_45test_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/cookie-test.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.name ?? "faq___en",
    path: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.path ?? "/faq",
    file: "/opt/buildhome/repo/pages/faq.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.name ?? "faq___fr",
    path: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.path ?? "/fr/faq",
    file: "/opt/buildhome/repo/pages/faq.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.name ?? "faq___es",
    path: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.path ?? "/es/faq",
    file: "/opt/buildhome/repo/pages/faq.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.name ?? "faq___it",
    path: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.path ?? "/it/faq",
    file: "/opt/buildhome/repo/pages/faq.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.name ?? "faq___de",
    path: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.path ?? "/de/faq",
    file: "/opt/buildhome/repo/pages/faq.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47faq_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.name ?? "gallery___en",
    path: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.path ?? "/gallery",
    file: "/opt/buildhome/repo/pages/gallery.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/gallery.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.name ?? "gallery___fr",
    path: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.path ?? "/fr/gallery",
    file: "/opt/buildhome/repo/pages/gallery.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/gallery.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.name ?? "gallery___es",
    path: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.path ?? "/es/gallery",
    file: "/opt/buildhome/repo/pages/gallery.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/gallery.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.name ?? "gallery___it",
    path: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.path ?? "/it/gallery",
    file: "/opt/buildhome/repo/pages/gallery.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/gallery.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.name ?? "gallery___de",
    path: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.path ?? "/de/gallery",
    file: "/opt/buildhome/repo/pages/gallery.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47gallery_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/gallery.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.name ?? "home___en",
    path: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.path ?? "/home",
    file: "/opt/buildhome/repo/pages/home.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47home_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/home.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.name ?? "home___fr",
    path: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.path ?? "/fr/home",
    file: "/opt/buildhome/repo/pages/home.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47home_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/home.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.name ?? "home___es",
    path: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.path ?? "/es/home",
    file: "/opt/buildhome/repo/pages/home.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47home_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/home.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.name ?? "home___it",
    path: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.path ?? "/it/home",
    file: "/opt/buildhome/repo/pages/home.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47home_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/home.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.name ?? "home___de",
    path: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.path ?? "/de/home",
    file: "/opt/buildhome/repo/pages/home.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47home_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47home_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/home.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.name ?? "index___en",
    path: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.path ?? "/",
    file: "/opt/buildhome/repo/pages/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.name ?? "index___fr",
    path: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.path ?? "/fr",
    file: "/opt/buildhome/repo/pages/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.name ?? "index___es",
    path: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.path ?? "/es",
    file: "/opt/buildhome/repo/pages/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.name ?? "index___it",
    path: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.path ?? "/it",
    file: "/opt/buildhome/repo/pages/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.name ?? "index___de",
    path: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.path ?? "/de",
    file: "/opt/buildhome/repo/pages/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.name ?? "logout___en",
    path: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.path ?? "/logout",
    file: "/opt/buildhome/repo/pages/logout.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.name ?? "logout___fr",
    path: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.path ?? "/fr/logout",
    file: "/opt/buildhome/repo/pages/logout.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.name ?? "logout___es",
    path: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.path ?? "/es/logout",
    file: "/opt/buildhome/repo/pages/logout.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.name ?? "logout___it",
    path: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.path ?? "/it/logout",
    file: "/opt/buildhome/repo/pages/logout.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.name ?? "logout___de",
    path: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.path ?? "/de/logout",
    file: "/opt/buildhome/repo/pages/logout.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47logout_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.name ?? "members-slug___en",
    path: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.path ?? "/members/:slug",
    file: "/opt/buildhome/repo/pages/members/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.name ?? "members-slug___fr",
    path: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.path ?? "/fr/members/:slug",
    file: "/opt/buildhome/repo/pages/members/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.name ?? "members-slug___es",
    path: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.path ?? "/es/members/:slug",
    file: "/opt/buildhome/repo/pages/members/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.name ?? "members-slug___it",
    path: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.path ?? "/it/members/:slug",
    file: "/opt/buildhome/repo/pages/members/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.name ?? "members-slug___de",
    path: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.path ?? "/de/members/:slug",
    file: "/opt/buildhome/repo/pages/members/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.name ?? "members-event-slug___en",
    path: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.path ?? "/members/event/:slug",
    file: "/opt/buildhome/repo/pages/members/event/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.name ?? "members-event-slug___fr",
    path: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.path ?? "/fr/members/event/:slug",
    file: "/opt/buildhome/repo/pages/members/event/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.name ?? "members-event-slug___es",
    path: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.path ?? "/es/members/event/:slug",
    file: "/opt/buildhome/repo/pages/members/event/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.name ?? "members-event-slug___it",
    path: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.path ?? "/it/members/event/:slug",
    file: "/opt/buildhome/repo/pages/members/event/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.name ?? "members-event-slug___de",
    path: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.path ?? "/de/members/event/:slug",
    file: "/opt/buildhome/repo/pages/members/event/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47event_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.name ?? "members___en",
    path: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.path ?? "/members",
    file: "/opt/buildhome/repo/pages/members/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.name ?? "members___fr",
    path: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.path ?? "/fr/members",
    file: "/opt/buildhome/repo/pages/members/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.name ?? "members___es",
    path: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.path ?? "/es/members",
    file: "/opt/buildhome/repo/pages/members/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.name ?? "members___it",
    path: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.path ?? "/it/members",
    file: "/opt/buildhome/repo/pages/members/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.name ?? "members___de",
    path: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.path ?? "/de/members",
    file: "/opt/buildhome/repo/pages/members/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.name ?? "members-profile___en",
    path: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.path ?? "/members/profile",
    file: "/opt/buildhome/repo/pages/members/profile/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/profile/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.name ?? "members-profile___fr",
    path: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.path ?? "/fr/members/profile",
    file: "/opt/buildhome/repo/pages/members/profile/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/profile/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.name ?? "members-profile___es",
    path: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.path ?? "/es/members/profile",
    file: "/opt/buildhome/repo/pages/members/profile/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/profile/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.name ?? "members-profile___it",
    path: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.path ?? "/it/members/profile",
    file: "/opt/buildhome/repo/pages/members/profile/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/profile/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.name ?? "members-profile___de",
    path: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.path ?? "/de/members/profile",
    file: "/opt/buildhome/repo/pages/members/profile/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47members_47profile_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/members/profile/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.name ?? "modularEvents-slug___en",
    path: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.path ?? "/modularEvents/:slug",
    file: "/opt/buildhome/repo/pages/modularEvents/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/modularEvents/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.name ?? "modularEvents-slug___fr",
    path: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.path ?? "/fr/modularEvents/:slug",
    file: "/opt/buildhome/repo/pages/modularEvents/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/modularEvents/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.name ?? "modularEvents-slug___es",
    path: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.path ?? "/es/modularEvents/:slug",
    file: "/opt/buildhome/repo/pages/modularEvents/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/modularEvents/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.name ?? "modularEvents-slug___it",
    path: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.path ?? "/it/modularEvents/:slug",
    file: "/opt/buildhome/repo/pages/modularEvents/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/modularEvents/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.name ?? "modularEvents-slug___de",
    path: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.path ?? "/de/modularEvents/:slug",
    file: "/opt/buildhome/repo/pages/modularEvents/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47modularEvents_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/modularEvents/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.name ?? "news-slug___en",
    path: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.path ?? "/news/:slug",
    file: "/opt/buildhome/repo/pages/news/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.name ?? "news-slug___fr",
    path: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.path ?? "/fr/news/:slug",
    file: "/opt/buildhome/repo/pages/news/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.name ?? "news-slug___es",
    path: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.path ?? "/es/news/:slug",
    file: "/opt/buildhome/repo/pages/news/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.name ?? "news-slug___it",
    path: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.path ?? "/it/news/:slug",
    file: "/opt/buildhome/repo/pages/news/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.name ?? "news-slug___de",
    path: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.path ?? "/de/news/:slug",
    file: "/opt/buildhome/repo/pages/news/[slug].vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47_91slug_93_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/[slug].vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.name ?? "news___en",
    path: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.path ?? "/news",
    file: "/opt/buildhome/repo/pages/news/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.name ?? "news___fr",
    path: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.path ?? "/fr/news",
    file: "/opt/buildhome/repo/pages/news/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.name ?? "news___es",
    path: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.path ?? "/es/news",
    file: "/opt/buildhome/repo/pages/news/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.name ?? "news___it",
    path: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.path ?? "/it/news",
    file: "/opt/buildhome/repo/pages/news/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.name ?? "news___de",
    path: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.path ?? "/de/news",
    file: "/opt/buildhome/repo/pages/news/index.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47news_47index_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.name ?? "nxtgen___en",
    path: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.path ?? "/nxtgen",
    file: "/opt/buildhome/repo/pages/nxtgen.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/nxtgen.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.name ?? "nxtgen___fr",
    path: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.path ?? "/fr/nxtgen",
    file: "/opt/buildhome/repo/pages/nxtgen.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/nxtgen.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.name ?? "nxtgen___es",
    path: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.path ?? "/es/nxtgen",
    file: "/opt/buildhome/repo/pages/nxtgen.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/nxtgen.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.name ?? "nxtgen___it",
    path: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.path ?? "/it/nxtgen",
    file: "/opt/buildhome/repo/pages/nxtgen.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/nxtgen.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.name ?? "nxtgen___de",
    path: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.path ?? "/de/nxtgen",
    file: "/opt/buildhome/repo/pages/nxtgen.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47nxtgen_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/nxtgen.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.name ?? "playground___en",
    path: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.path ?? "/playground",
    file: "/opt/buildhome/repo/pages/playground.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/playground.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.name ?? "playground___fr",
    path: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.path ?? "/fr/playground",
    file: "/opt/buildhome/repo/pages/playground.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/playground.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.name ?? "playground___es",
    path: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.path ?? "/es/playground",
    file: "/opt/buildhome/repo/pages/playground.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/playground.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.name ?? "playground___it",
    path: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.path ?? "/it/playground",
    file: "/opt/buildhome/repo/pages/playground.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/playground.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.name ?? "playground___de",
    path: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.path ?? "/de/playground",
    file: "/opt/buildhome/repo/pages/playground.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47playground_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/playground.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.name ?? "sign-up___en",
    path: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.path ?? "/sign-up",
    file: "/opt/buildhome/repo/pages/sign-up.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/sign-up.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.name ?? "sign-up___fr",
    path: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.path ?? "/fr/sign-up",
    file: "/opt/buildhome/repo/pages/sign-up.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/sign-up.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.name ?? "sign-up___es",
    path: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.path ?? "/es/sign-up",
    file: "/opt/buildhome/repo/pages/sign-up.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/sign-up.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.name ?? "sign-up___it",
    path: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.path ?? "/it/sign-up",
    file: "/opt/buildhome/repo/pages/sign-up.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/sign-up.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.name ?? "sign-up___de",
    path: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.path ?? "/de/sign-up",
    file: "/opt/buildhome/repo/pages/sign-up.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47sign_45up_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/sign-up.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.name ?? "spacecraft-fleet___en",
    path: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.path ?? "/spacecraft-fleet",
    file: "/opt/buildhome/repo/pages/spacecraft-fleet.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spacecraft-fleet.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.name ?? "spacecraft-fleet___fr",
    path: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.path ?? "/fr/spacecraft-fleet",
    file: "/opt/buildhome/repo/pages/spacecraft-fleet.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spacecraft-fleet.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.name ?? "spacecraft-fleet___es",
    path: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.path ?? "/es/spacecraft-fleet",
    file: "/opt/buildhome/repo/pages/spacecraft-fleet.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spacecraft-fleet.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.name ?? "spacecraft-fleet___it",
    path: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.path ?? "/it/spacecraft-fleet",
    file: "/opt/buildhome/repo/pages/spacecraft-fleet.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spacecraft-fleet.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.name ?? "spacecraft-fleet___de",
    path: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.path ?? "/de/spacecraft-fleet",
    file: "/opt/buildhome/repo/pages/spacecraft-fleet.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spacecraft_45fleet_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spacecraft-fleet.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.name ?? "spaceflight-experience___en",
    path: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.path ?? "/spaceflight-experience",
    file: "/opt/buildhome/repo/pages/spaceflight-experience.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceflight-experience.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.name ?? "spaceflight-experience___fr",
    path: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.path ?? "/fr/spaceflight-experience",
    file: "/opt/buildhome/repo/pages/spaceflight-experience.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceflight-experience.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.name ?? "spaceflight-experience___es",
    path: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.path ?? "/es/spaceflight-experience",
    file: "/opt/buildhome/repo/pages/spaceflight-experience.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceflight-experience.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.name ?? "spaceflight-experience___it",
    path: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.path ?? "/it/spaceflight-experience",
    file: "/opt/buildhome/repo/pages/spaceflight-experience.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceflight-experience.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.name ?? "spaceflight-experience___de",
    path: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.path ?? "/de/spaceflight-experience",
    file: "/opt/buildhome/repo/pages/spaceflight-experience.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceflight_45experience_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceflight-experience.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.name ?? "spaceport-america___en",
    path: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.path ?? "/spaceport-america",
    file: "/opt/buildhome/repo/pages/spaceport-america.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceport-america.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.name ?? "spaceport-america___fr",
    path: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.path ?? "/fr/spaceport-america",
    file: "/opt/buildhome/repo/pages/spaceport-america.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceport-america.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.name ?? "spaceport-america___es",
    path: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.path ?? "/es/spaceport-america",
    file: "/opt/buildhome/repo/pages/spaceport-america.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceport-america.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.name ?? "spaceport-america___it",
    path: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.path ?? "/it/spaceport-america",
    file: "/opt/buildhome/repo/pages/spaceport-america.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceport-america.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.name ?? "spaceport-america___de",
    path: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.path ?? "/de/spaceport-america",
    file: "/opt/buildhome/repo/pages/spaceport-america.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47spaceport_45america_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/spaceport-america.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.name ?? "thank-you___en",
    path: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.path ?? "/thank-you",
    file: "/opt/buildhome/repo/pages/thank-you.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/thank-you.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.name ?? "thank-you___fr",
    path: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.path ?? "/fr/thank-you",
    file: "/opt/buildhome/repo/pages/thank-you.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/thank-you.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.name ?? "thank-you___es",
    path: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.path ?? "/es/thank-you",
    file: "/opt/buildhome/repo/pages/thank-you.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/thank-you.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.name ?? "thank-you___it",
    path: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.path ?? "/it/thank-you",
    file: "/opt/buildhome/repo/pages/thank-you.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/thank-you.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.name ?? "thank-you___de",
    path: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.path ?? "/de/thank-you",
    file: "/opt/buildhome/repo/pages/thank-you.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47thank_45you_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/thank-you.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.name ?? "verify___en",
    path: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.path ?? "/verify",
    file: "/opt/buildhome/repo/pages/verify.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/verify.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.name ?? "verify___fr",
    path: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.path ?? "/fr/verify",
    file: "/opt/buildhome/repo/pages/verify.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/verify.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.name ?? "verify___es",
    path: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.path ?? "/es/verify",
    file: "/opt/buildhome/repo/pages/verify.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/verify.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.name ?? "verify___it",
    path: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.path ?? "/it/verify",
    file: "/opt/buildhome/repo/pages/verify.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/verify.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.name ?? "verify___de",
    path: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.path ?? "/de/verify",
    file: "/opt/buildhome/repo/pages/verify.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47verify_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/verify.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.name ?? "webgl-sandbox___en",
    path: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.path ?? "/webgl-sandbox",
    file: "/opt/buildhome/repo/pages/webgl-sandbox.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/webgl-sandbox.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.name ?? "webgl-sandbox___fr",
    path: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.path ?? "/fr/webgl-sandbox",
    file: "/opt/buildhome/repo/pages/webgl-sandbox.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/webgl-sandbox.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.name ?? "webgl-sandbox___es",
    path: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.path ?? "/es/webgl-sandbox",
    file: "/opt/buildhome/repo/pages/webgl-sandbox.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/webgl-sandbox.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.name ?? "webgl-sandbox___it",
    path: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.path ?? "/it/webgl-sandbox",
    file: "/opt/buildhome/repo/pages/webgl-sandbox.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/webgl-sandbox.vue").then(m => m.default || m)
  },
  {
    name: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.name ?? "webgl-sandbox___de",
    path: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.path ?? "/de/webgl-sandbox",
    file: "/opt/buildhome/repo/pages/webgl-sandbox.vue",
    children: [],
    meta: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta,
    alias: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.alias || [],
    redirect: _47opt_47buildhome_47repo_47pages_47webgl_45sandbox_46vueMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/webgl-sandbox.vue").then(m => m.default || m)
  }
]